import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { TerminalDetailsDto } from '../../../models/terminals/terminalDetailsDto';

interface ClientsCardProps {
  terminal?: TerminalDetailsDto;
}

export const ClientsCard: React.FC<ClientsCardProps> = ({ terminal }) => (
  <Box className="gbr" px={2} pb={2} sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
    <Typography variant="h5" fontWeight="bold" sx={{ pt: 2, pb: 1 }}>
      Клиенты
    </Typography>
    <Box>
      <Typography variant="body1" sx={{ marginBottom: 1 }} className="grey">Название</Typography>
      <Grid container spacing={2} paddingLeft={0} paddingBottom={1} textAlign="center">
        {terminal?.companies ? terminal.companies.map((company, index) => (
          <Box key={index} className="gbr" py={1} px={2} mt={1.5} ml={2}>
            <Typography variant="body2" fontWeight="bold" key={company.id}>{company.name}</Typography>
          </Box>
        )) : ''}
      </Grid>
    </Box>
  </Box>
);
